import React from "react";
import { Form, Button, Row, Col } from "antd";
import FormInput from "../common/FormInput";

const SendTestEmail = ({
  EmailFields,
  getFieldDecorator,
  onSendTestCampaign
}) => {
  return (
    <Form
      onSubmit={onSendTestCampaign}
      layout="inline"
      className="campaign-form"
      style={{ marginTop: 20, marginBottom: 10 }}
    >
      <Row>
        <Col>
          {EmailFields &&
            EmailFields.map((field, index) => (
              <FormInput
                label="Send a test email"
                key={index}
                field={field}
                getFieldDecorator={getFieldDecorator}
              />
            ))}

          <Form.Item>
            <Button type="ghost" htmlType="submit" className="login-form-button">
              Send Email
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default SendTestEmail;
